import { useInactivityTimeout } from './useInactivityTimeout';

interface UseChatActivityTrackingProps {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
  closeForm: () => void;
  setShowNewConversationDialog: (show: boolean) => void;
}

export const useChatActivityTracking = ({
  isExpanded,
  setIsExpanded,
  closeForm,
  setShowNewConversationDialog
}: UseChatActivityTrackingProps) => {
  // Auto-collapse on inactivity
  const { recordActivity } = useInactivityTimeout({
    isExpanded,
    onTimeout: async () => {
      // Import sessionManager to clear conversation state
      const { sessionManager } = await import('@/utils/sessionManager');
      sessionManager.clearSession();
      
      // Trigger browser event to notify OpenAI hook to clear conversation
      window.dispatchEvent(new CustomEvent('d2c-clear-conversation', { 
        detail: { reason: 'inactivity_timeout' } 
      }));
      
      setIsExpanded(false);
      // Clear any forms and reset state
      closeForm();
      setShowNewConversationDialog(false);
    },
    timeoutMs: 10 * 60 * 1000 // 10 minutes
  });

  return {
    recordActivity,
  };
};